export class NotesDetails {

  public noteId: number;
  public noteContent: string;
  public createdBy: number;
  public createdDate: Date;
  public lastModifiedBy: number;
  public lastModifiedDate: Date;
}
